// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Lr7R","label":"Radio_label__14m34","checkMark":"Radio_checkMark__1Jgeb","disabled":"Radio_disabled__36I3W"};